export const forwardingConstants = {
  FORWARDING_SUCCESS: 'FORWARDING_SUCCESS',
  FORWARDING_ERROR: 'FORWARDING_ERROR',
  FORWARDING_REQUEST: 'FORWARDING_REQUEST',
};
